package com.partejar.app.feature.auth.presentation

sealed class AuthAction {
    data class OnNomeChanged(val nome: String) : AuthAction()
    data class OnEmailChanged(val email: String) : AuthAction()
    data class OnSenhaChanged(val senha: String) : AuthAction()
    data class OnConfirmacaoSenhaChanged(val confirmacao: String) : AuthAction()
    data object OnLoginClicked : AuthAction()
    data object OnRegisterClicked : AuthAction()
    data object OnRegistrationModeToggled : AuthAction()
    data object OnErrorDismissed : AuthAction()
}
